import { ExternalScript } from '../store/config/config.reducer';

export const getRetentionScript = (canonicalURL: string): ExternalScript[] => {
  const keywords = ['/golf', '/nfl', '/betting', '/fantasy', '/nba'];

  if (
    !keywords.some(keyword => canonicalURL.includes(`www.si.com${keyword}`))
  ) {
    return [];
  }

  const script = `
  !function(){var geq=window.geq=window.geq||[];if(geq.initialize) return;if (geq.invoked){if (window.console && console.error) 
  {console.error("GE snippet included twice.");}return;}
  geq.invoked = true;
  geq.methods = ["page", "suppress", "track", "doNotTrack", "trackOrder", "identify", "addToCart", "callBack", "event"];
  geq.factory = function(method){return function(){var args = Array.prototype.slice.call(arguments);
  args.unshift(method);geq.push(args);return geq;};};
  for (var i = 0; i < geq.methods.length; i++) {var key = geq.methods[i];geq[key] = geq.factory(key);} 
  geq.load = function(key){var script = document.createElement("script");
  script.type = "text/javascript";script.async = true;
  if (location.href.includes("vge=true")) {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js?v=" + Math.random();} 
  else {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js";} var first = document.getElementsByTagName("script")[0];
  first.parentNode.insertBefore(script, first);};geq.SNIPPET_VERSION = "1.6.1";geq.load("350HNG3Z");}();

  setTimeout(function () {
    geq.page();
  }, 60000);

 (function () {
  let isAttached = false;
  let lastFire = 0;
  const FIRE_WINDOW_MS = 300; // adjust if needed
  let observer;

  function suppress() {
    if (typeof window?.geq?.suppress === 'function') {
      console.warn('Retention suppression fired on form submit');
      window?.geq?.suppress();
    }
  }

  function fireOnce() {
    const now = Date.now();
    if (now - lastFire < FIRE_WINDOW_MS) return; // debounce
    lastFire = now;
    suppress();
  }

  function attachListener() {
    if (isAttached) return;

    const form = Array.from(document.getElementsByTagName('form'))
      .find(f => f.querySelector('.bcForm'));

    if (!form) return;

    const submitButton = form.querySelector('input[type="submit"]');
    if (!submitButton) return;

    submitButton.addEventListener('click', fireOnce, { capture: true });
    submitButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') fireOnce();
    }, { capture: true });

    isAttached = true;

    // make sure observer is defined before disconnecting
    if (observer) {
      observer.disconnect(); // no need to keep watching if form is present
    }
  }

  window.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(attachListener);
    observer.observe(document.body, { childList: true, subtree: true });

    attachListener();
  });
})();
`;

  return [
    {
      type: 'code',
      source: script,
      name: 'retention',
      attributes: null,
      loadingType: 'async',
    },
  ];
};
